import React, { useEffect, useState } from 'react';
import { Button, Divider, Dropdown, Form, Popconfirm, Switch } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import ModalDelete from '../Shared/modal/delete';

import Question, { QUESTION_TYPE } from './Question';
import { ICON } from './icon';

export const Forms = ({ forms = [] }) => {
    return (
        <div>
            <div className="bg-[#312966] h-3 w-full rounded-t-md"></div>
            <div className="px-4 pb-4 pt-2">
                {forms.map((form, index) => (
                    <Question key={index} form={form} />
                ))}
            </div>
        </div>
    );
};

export const FormsPart = ({
    forms,
    part,
    partLength,
    openModal,
    remove,
    dulicateGroup,
}) => {
    const [openModalDelete, setOpenModalDelete] = useState(false);

    const items = [
        {
            key: '1',
            label: 'ทำสำเนาส่วน',
            onClick: () => dulicateGroup(),
        },
        {
            key: '2',
            label: 'ย้ายส่วน',
            onClick: () => openModal(),
        },
        {
            key: '3',
            label: 'ลบส่วน',
            onClick: () => setOpenModalDelete(true),
            disabled: partLength === 1,
        },
    ];
    return (
        <>
            <div className="bg-[#312966] p-4 w-full rounded-t-md flex items-center justify-between">
                <span className="text-white font-semibold">
                    ส่วนที่ {part} จาก {partLength}
                </span>
                <Dropdown
                    menu={{
                        items,
                    }}
                    placement="bottom"
                >
                    <Button
                        icon={<MoreOutlined className="rotate-90" />}
                    ></Button>
                </Dropdown>
            </div>
            <div className="px-4 pb-4 pt-2">
                {forms.map((form, index) => (
                    <Question key={index} form={form} />
                ))}
            </div>
            <ModalDelete
                text="เมื่อ “ยืนยัน” ลบแล้ว ชุดคำถามในส่วนนี้จะถูกลบออกทั้งหมด"
                title="ยืนยันลบส่วนนี้ ?"
                open={openModalDelete}
                handelOk={() => {
                    remove();
                    setOpenModalDelete(false);
                }}
                handelClose={() => setOpenModalDelete(false)}
            />
        </>
    );
};

const SwitchFormItem = ({ form, item, part }) => {
    const questionComponents = {
        [QUESTION_TYPE.SELECT]: Question.Select,
        [QUESTION_TYPE.EDITOR]: Question,
        [QUESTION_TYPE.RADIO]: Question.Multiple,
        [QUESTION_TYPE.CHECKBOX]: Question.Multiple,
        [QUESTION_TYPE.DATE_TIME]: Question.DateTime,
        [QUESTION_TYPE.DATE]: Question.DateTime,
        [QUESTION_TYPE.SHORT]: Question.Short,
        [QUESTION_TYPE.LONG]: Question.Long,
        [QUESTION_TYPE.UPLOAD]: Question.Upload,
        [QUESTION_TYPE.TOPIC]: () => <div />,
        [QUESTION_TYPE.OTP]: Question.Otp,
    };

    const QuestionComponent = questionComponents[form.type] || (() => <div />);
    const questionProps = { form, part, item, type: form.type };

    return <QuestionComponent {...questionProps} />;
};

export const FormsSub = ({
    duplicateItem,
    dragHandleProps,
    targetRef,
    setSelectItem,
    items: { item, groupIndex, index, options },
}) => {
    const form = Form.useFormInstance();
    const part = form.getFieldValue('part');
    const [formState, setFormState] = useState([]);

    useEffect(() => {
        setFormState([
            {
                label: 'คำถามนี้เกี่ยวกับเรื่องอะไร',
                name: [groupIndex, 'groupQuestion', index, 'storyId'],
                rules: [
                    {
                        required: true,
                        message: "กรุณาเลือก 'คำถามนี้เกี่ยวกับเรื่องอะไร'",
                    },
                ],
                type: QUESTION_TYPE.SELECT,
                placeholder: 'คำถามนี้เกี่ยวกับเรื่องอะไร กรุณาเลือก',
                options,
            },
            {
                label: 'คำถาม',
                name: [groupIndex, 'groupQuestion', index, 'questionName'],
                initialValue: '',
                rules: [],
                type: QUESTION_TYPE.EDITOR,
            },
        ]);
    }, [groupIndex, index, options]);

    useEffect(() => {
        if (item.isDescription) {
            setFormState((prev) => [
                ...prev,
                {
                    label: 'คำอธิบาย (ถ้ามี)',
                    name: [
                        groupIndex,
                        'groupQuestion',
                        index,
                        'questionDescription',
                    ],
                    initialValue: '',
                    rules: [],
                    type: QUESTION_TYPE.EDITOR,
                },
            ]);
        } else {
            setFormState((prev) =>
                prev.filter(
                    (form) =>
                        form.name[form.name.length - 1] !==
                        'questionDescription'
                )
            );
        }
    }, [groupIndex, index, item.isDescription]);

    const _form = {
        label: 'คำตอบ',
        name: [groupIndex, 'groupQuestion', index, 'answerValue'],
        initialValue: null,
        rules: [],
        disabled: true,
        type: item.answerType,
    };

    const onRemove = () => {
        const newState = [...part];
        newState[groupIndex].groupQuestion.splice(index, 1);
        const groupId = newState[groupIndex].id;
        const mainGroup = newState[groupIndex].groupQuestion;

        const selectItem = mainGroup[index - 1]
            ? {
                  id: mainGroup[index - 1].id,
                  group: groupId,
                  type: 'item',
              }
            : {
                  id: groupId,
                  type: 'group',
              };

        setTimeout(() => {
            form.setFieldValue('part', newState);
            setSelectItem(selectItem);
        }, 300);
    };

    return (
        <>
            <div
                {...dragHandleProps}
                className="flex justify-center w-full py-8"
            >
                <svg
                    width="12"
                    height="4"
                    viewBox="0 0 12 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.3337 0H0.666992V1.33333H11.3337V0ZM0.666992 4H11.3337V2.66667H0.666992V4Z"
                        fill="#7B67FB"
                    />
                </svg>
            </div>
            <div className="flex px-4 space-x-2">
                <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.42863 0.572266C7.11298 0.572018 5.81913 0.908256 4.67007 1.54902C3.521 2.18978 2.5549 3.11378 1.86361 4.23318C1.17232 5.35257 0.778809 6.63017 0.720478 7.94453C0.662146 9.25888 0.940936 10.5663 1.53035 11.7425L0.752061 14.6474C0.703625 14.8289 0.703775 15.02 0.752499 15.2015C0.801222 15.3829 0.896805 15.5484 1.02966 15.6812C1.16251 15.8141 1.32797 15.9097 1.50942 15.9584C1.69088 16.0071 1.88196 16.0073 2.06349 15.9588L4.96663 15.1823C6.00711 15.7041 7.15218 15.9836 8.31605 16.0001C9.47992 16.0165 10.6324 15.7693 11.6872 15.2771C12.742 14.7848 13.6717 14.0603 14.4067 13.1577C15.1417 12.2551 15.6629 11.1979 15.9313 10.0653C16.1997 8.93266 16.2083 7.75398 15.9564 6.61756C15.7046 5.48114 15.1989 4.41644 14.4771 3.50323C13.7554 2.59002 12.8364 1.85198 11.7889 1.34439C10.7414 0.836802 9.59262 0.572835 8.42863 0.572266ZM8.42863 13.0008C8.2013 13.0008 7.98329 12.9105 7.82254 12.7498C7.6618 12.589 7.57149 12.371 7.57149 12.1437C7.57149 11.9164 7.6618 11.6983 7.82254 11.5376C7.98329 11.3769 8.2013 11.2866 8.42863 11.2866C8.65596 11.2866 8.87398 11.3769 9.03472 11.5376C9.19547 11.6983 9.28578 11.9164 9.28578 12.1437C9.28578 12.371 9.19547 12.589 9.03472 12.7498C8.87398 12.9105 8.65596 13.0008 8.42863 13.0008ZM7.14292 5.93455C7.14224 6.10505 7.07385 6.26829 6.95281 6.38837C6.83177 6.50844 6.66799 6.57552 6.49749 6.57484C6.32699 6.57415 6.16375 6.50577 6.04367 6.38473C5.9236 6.26369 5.85652 6.0999 5.8572 5.92941V5.91312C5.85805 5.87678 5.86005 5.84048 5.8632 5.80427C5.89254 5.43641 6.0007 5.07918 6.18035 4.75684C6.53349 4.13112 7.22692 3.57227 8.42863 3.57227C9.63035 3.57227 10.3246 4.13112 10.6761 4.75684C10.8698 5.10335 10.9807 5.49002 11.0001 5.88655L11.0009 5.92941V5.93027C11.0009 6.89369 10.4078 7.54169 9.97835 8.01141L9.8712 8.12884C9.4032 8.64826 9.07235 9.08027 9.07235 9.78741C9.07235 9.9579 9.00462 10.1214 8.88406 10.242C8.7635 10.3625 8.59999 10.4303 8.42949 10.4303C8.25899 10.4303 8.09548 10.3625 7.97492 10.242C7.85436 10.1214 7.78663 9.9579 7.78663 9.78741C7.78663 8.56598 8.42006 7.81941 8.91635 7.26827L8.93178 7.25112C9.45378 6.67084 9.71349 6.38284 9.71521 5.93541V5.93284C9.7035 5.74187 9.64933 5.55592 9.55663 5.38855C9.42549 5.15627 9.15463 4.85798 8.42863 4.85798C7.70263 4.85798 7.43178 5.15627 7.30149 5.38769C7.20843 5.55584 7.15424 5.7427 7.14292 5.93455ZM13.5715 19.4294C12.4808 19.4306 11.4024 19.1999 10.4076 18.7528C9.41276 18.3056 8.52435 17.6522 7.8012 16.8357C8.40414 16.8801 9.01009 16.8605 9.60892 16.7774C10.7391 17.6645 12.1348 18.1457 13.5715 18.1437C14.6468 18.1454 15.7051 17.876 16.6486 17.3603C16.794 17.2808 16.9644 17.2606 17.1243 17.3037L19.9101 18.0494L19.1626 15.262C19.12 15.1026 19.1402 14.9329 19.2192 14.788C19.732 13.8449 20.0004 12.7885 20.0001 11.7151C20.0004 10.5738 19.6968 9.45301 19.1207 8.46784C18.5445 7.48266 17.7164 6.66864 16.7215 6.10941C16.5675 5.5243 16.352 4.95714 16.0786 4.41741C17.1189 4.77509 18.0707 5.35103 18.8702 6.10661C19.6697 6.86219 20.2985 7.77996 20.7143 8.79839C21.1301 9.81682 21.3234 10.9124 21.2813 12.0116C21.2391 13.1109 20.9624 14.1884 20.4698 15.172L21.2481 18.076C21.2966 18.2576 21.2964 18.4488 21.2477 18.6303C21.1989 18.8119 21.1033 18.9774 20.9703 19.1103C20.8373 19.2432 20.6717 19.3387 20.4901 19.3874C20.3085 19.436 20.1174 19.436 19.9358 19.3874L17.0335 18.6108C15.959 19.1497 14.7735 19.43 13.5715 19.4294ZM9.71435 5.93455V5.93627V5.93198"
                        fill="#7B67FB"
                    />
                </svg>
                <div>
                    <div className="text-purple-PHX  font-semibold">
                        กรุณากำหนดเรื่อง
                    </div>
                    <div className="text-[#65707A]">
                        เป็นการกำหนดว่าคำถามข้อนี้ เกี่ยวข้องกับเรื่องใด
                        เพื่อให้ระบบสามารถนำคำตอบนี้ในการออกรายงานได้อย่างถูกต้อง
                    </div>
                </div>
            </div>
            <div className="p-4">
                {formState?.map((form, index) => (
                    <SwitchFormItem key={index} form={form} />
                ))}
                <SwitchFormItem part={part} item={item} form={_form} />
                <div className="flex items-center gap-2 w-max ml-auto mt-4">
                    <div>
                        <button onClick={duplicateItem} type="button">
                            {ICON.dup}
                        </button>
                        <Popconfirm
                            title={
                                <div>
                                    <strong>ยืนยันการลบ</strong>
                                    <div>
                                        การลบนี้มีผลทำให้ชุดคำถามหายไปจาก <br />
                                        แบบฟอร์ม ยืนยันลบหรือไม่ ?
                                    </div>
                                </div>
                            }
                            onConfirm={onRemove}
                            okText="ยืนยัน"
                            cancelText="ยกเลิก"
                            okButtonProps={{
                                className:
                                    'bg-[#F0536F] text-white border-none hover:bg-[#F0536F]/80',
                            }}
                        >
                            <button type="button">{ICON.del}</button>
                        </Popconfirm>
                    </div>
                    <Divider className="h-8" type="vertical" />
                    {item.answerType !== QUESTION_TYPE.TOPIC && (
                        <div className="flex items-center gap-2">
                            <div>จำเป็น</div>
                            <Form.Item
                                noStyle
                                name={[
                                    groupIndex,
                                    'groupQuestion',
                                    index,
                                    'isRequire',
                                ]}
                                valuePropName="checked"
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                    )}
                    <div className="flex items-center gap-2">
                        <div>แสดงคำอธิบาย</div>
                        <Form.Item
                            noStyle
                            name={[
                                groupIndex,
                                'groupQuestion',
                                index,
                                'isDescription',
                            ]}
                            valuePropName="checked"
                        >
                            <Switch />
                        </Form.Item>
                    </div>
                    {item.answerType === QUESTION_TYPE.RADIO && (
                        <div className="flex items-center gap-2">
                            <div>ข้ามไปยังส่วนอื่น</div>
                            <Form.Item
                                noStyle
                                name={[
                                    groupIndex,
                                    'groupQuestion',
                                    index,
                                    'isSkip',
                                ]}
                                valuePropName="checked"
                            >
                                <Switch />
                            </Form.Item>
                        </div>
                    )}
                </div>
            </div>
            <div ref={targetRef} />
        </>
    );
};

SwitchFormItem.propTypes = {
    form: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    part: PropTypes.array.isRequired,
};

Forms.propTypes = {
    forms: PropTypes.array.isRequired,
};

FormsPart.propTypes = {
    forms: PropTypes.array.isRequired,
    part: PropTypes.number.isRequired,
    partLength: PropTypes.number.isRequired,
    openModal: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    dulicateGroup: PropTypes.func.isRequired,
};

FormsSub.propTypes = {
    duplicateItem: PropTypes.func.isRequired,
    dragHandleProps: PropTypes.object,
    targetRef: PropTypes.object,
    setSelectItem: PropTypes.func.isRequired,
    items: PropTypes.shape({
        item: PropTypes.object.isRequired,
        groupIndex: PropTypes.number.isRequired,
        index: PropTypes.number.isRequired,
        options: PropTypes.array.isRequired,
    }).isRequired,
};
